import React from "react";
import "./Thumbnail.scss";

const ClassicSmallThumbnail = ({ image, title }) => {
  console.log(image);
  console.log(title);
  return (
    <div className="classic-small-thumbnail">
      <div className="img" style={{ backgroundImage: `url(${image})` }}></div>
      <div className="title-thumbnail">{title}</div>
    </div>
  );
};

export default ClassicSmallThumbnail;
